import { getAllowRole } from "@/utils/get-roles.js";
const state = () => {
  return {
    menu: [
      {
        icon: "GlobeIcon",
        pageName: "landing-page",
        title: "หน้าหลัก",
        permissions: getAllowRole("landing-page"),
      },
      {
        icon: "ActivityIcon",
        title: "Dashboard",
        subMenu: [
          {
            icon: "BarChart2Icon",
            pageName: "dashboard-overview",
            title: "ภาพรวมโครงการ",
            permissions: getAllowRole("dashboard-overview"),
          },
          {
            icon: "BarChart2Icon",
            pageName: "household-dashboard",
            title: "ครัวเรือนที่ประสบปัญหา",
            permissions: getAllowRole("household-dashboard"),
          },
        ],
      },
      {
        icon: "FileTextIcon",
        title: "รายงาน",
        subMenu: [
          {
            icon: "",
            pageName: "report-page-1",
            title: "[1] สรุปผลการจัดทำข้อมูล",
            permissions: getAllowRole("report-page-1"),
          },
          {
            icon: "",
            pageName: "report-page-2",
            title: "[2] สรุปปัญหา",
            permissions: getAllowRole("report-page-2"),
          },
          {
            icon: "",
            pageName: "report-page-3",
            title: "[3] ติดตามการแก้ไขปัญหา",
            permissions: getAllowRole("report-page-3"),
          },
          {
            icon: "",
            pageName: "report-page-4",
            title: "[4] การปฏิบัติงานรายเดือน",
            permissions: getAllowRole("report-page-4"),
          },
          // {
          //   icon: "",
          //   pageName: "report-page-5",
          //   title: "[5] ติดตามกลุ่มเป้าหมาย",
          //   permissions: getAllowRole("report-page-5"),
          // },
        ],
      },
      {
        icon: "LayoutIcon",
        pageName: "pivot-table",
        title: "รายงาน PIVOT",
        permissions: getAllowRole("pivot-table"),
      },
      {
        icon: "HomeIcon",
        pageName: "main-house-hold",
        title: "ครัวเรือน",
        permissions: getAllowRole("main-house-hold"),
      },
      {
        icon: "UsersIcon",
        pageName: "family-page",
        title: "ครอบครัว",
        permissions: getAllowRole("family-page"),
      },
      {
        icon: "UserIcon",
        pageName: "member-page",
        title: "สมาชิก",
        permissions: getAllowRole("member-page"),
      },
      // {
      //   icon: "HandHoldingDollarIcon",
      //   pageName: "welfare-page",
      //   title: "สวัสดิการแบบครบวงจร",
      //   permissions: getAllowRole("welfare-page"),
      // },
      {
        icon: "FileTextIcon",
        pageName: "news",
        title: "ข่าวประกาศ",
        permissions: getAllowRole("news"),
      },
      {
        icon: "UsersIcon",
        pageName: "user-management",
        title: "จัดการผู้ใช้งาน",
        permissions: getAllowRole("user-management"),
      },
      {
        icon: "UsersIcon",
        pageName: "user-hcm-management",
        title: "จัดการข้อมูล CM",
        permissions: getAllowRole("user-hcm-management"),
      },
      {
        icon: "LinkIcon",
        pageName: "linkage-center",
        title: "ทดสอบ Linkage Center 2",
        permissions: getAllowRole("linkage-center"),
      },
    ],
  };
};

// getters
const getters = {
  menu: (state) => state.menu,
};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
